import React from 'react'
import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'
import { useQuery } from '@apollo/client'
import { TOP_VENUES } from '@graphql/venue/venue.query'
import { pageLoading } from '@shared/libs/allLoader'
import VenueLayout from './layout'
import NoData from '@shared/components/noData'
import { handleApiError } from '@shared-submodule/utils'
import queryGraphql from '@shared/components/queryGraphql'
import { GET_SEO_DATA } from '@graphql/article/article.query'
import Layout from '@shared/components/layout'

const TopVenue = dynamic(() => import('@shared/components/venueWidget/topVenue'))

function Venue({ input, seoData }) {
  const { data, loading } = useQuery(TOP_VENUES, {
    variables:
    {
      input: {
        nSkip: 0,
        nLimit: 10
      }
    }
  })

  if (loading) return pageLoading()

  const venueDetails = data?.getTopVenues || []
  return (
    <>
      <Layout data={{ oSeo: seoData }}>
        <VenueLayout>
          {venueDetails.length === 0 ? <NoData title='This Venue’s a Ghost! Nothing here but tumbleweeds. Try another search to find your spot.' /> : <TopVenue venueData={venueDetails} />
          }
        </VenueLayout>
      </Layout>
    </>
  )
}

Venue.propTypes = {
  input: PropTypes.object,
  seoData: PropTypes.object
}

export default Venue

export async function getServerSideProps({ res, resolvedUrl }) {
  try {
    const { data: seoData } = await queryGraphql(GET_SEO_DATA, { input: { sSlug: 'cricket/venues' } })
    return {
      props: {
        seoData: seoData?.getSeoData || {}
      }
    }
  } catch (e) {
    res.setHeader('Cache-Control', 'no-cache')
    const status = handleApiError(e, resolvedUrl)
    return status
  }
}
